import { userHasPermission } from './permissions';

/**
 * @param {string} pathname
 * @param {import('../../app/routeConfig').AppRoute[]} routes
 */
export function matchRoute(pathname, routes) {
  return routes
    .filter((route) => route.path && !route.public && route.element)
    .find((route) => {
      if (route.path === '/') return pathname === '/';
      const base = route.path.split('/:')[0];
      return pathname === route.path || pathname.startsWith(`${base}/`);
    });
}

/**
 * @param {import('../auth/AuthContext').User | null} user
 * @param {string} pathname
 * @param {import('../../app/routeConfig').AppRoute[]} routes
 */
export function canAccessPath(user, pathname, routes) {
  const route = matchRoute(pathname, routes);
  if (!route?.permission) return true;
  return userHasPermission(user, route.permission);
}

/**
 * @param {import('../auth/AuthContext').User | null} user
 * @param {import('../../app/routeConfig').AppRoute[]} routes
 */
export function getFirstAccessiblePath(user, routes) {
  const match = routes.find(
    (route) =>
      route.path &&
      !route.public &&
      route.element &&
      (!route.permission || userHasPermission(user, route.permission)),
  );
  return match?.path ?? null;
}

/**
 * @param {import('../auth/AuthContext').User | null} user
 * @param {string | undefined} fromPathname
 * @param {import('../../app/routeConfig').AppRoute[]} routes
 */
export function resolvePostLoginPath(user, fromPathname, routes) {
  if (
    fromPathname &&
    fromPathname !== '/login' &&
    fromPathname !== '/unauthorized' &&
    canAccessPath(user, fromPathname, routes)
  ) {
    return fromPathname;
  }
  return getFirstAccessiblePath(user, routes) ?? '/unauthorized';
}
